import ApiService from '../../../shared/services/ApiService';

const API_V1_AUTH = '/api/v1/auth';

export interface UserPageAnnouncement {
  shouldShow: boolean;
  hasExperienceReview: boolean;
}

class AuthApiService extends ApiService {
  public fetchAuth(): Promise<{
    authenticated: boolean;
    isWorking: boolean;
    imageUrl: string | null;
    message: string | string[] | null;
    userPageAnnouncement?: UserPageAnnouncement;
  }> {
    return this.request(API_V1_AUTH, this.METHOD.GET);
  }
}

export default AuthApiService;
